import { ColumnMode } from "components/DragDropList/types";
import { AnalyticsPageDashboard } from "hooks/useAnalytics/pages/dashboard";

export enum Widget {
  FavoriteStacks = "FavoriteStacks",
  StacksState = "StacksState",
  StacksSize = "StacksSize",
  StacksFailures = "StacksFailures",
  DriftDetectionCoverage = "DriftDetectionCoverage",
  RecentDriftDetectionRuns = "RecentDriftDetectionRuns",
  NextDriftDetectionSchedule = "NextDriftDetectionSchedule",
  RunsThatRequireAttention = "RunsThatRequireAttention",
  StacksRequiringAttention = "StacksRequiringAttention",
  AverageRunDuration = "AverageRunDuration",
  MedianRunDuration = "MedianRunDuration",
  // ManagedResourcesOverTime = "ManagedResourcesOverTime",
  ManagedResources = "ManagedResources",
  ResourcesHealth = "ResourcesHealth",
  NumberOfDeployments = "NumberOfDeployments",
  ApprovalPolicyEvaluations = "ApprovalPolicyEvaluations",
  DoraLeadTimeChanges = "DoraLeadTimeChanges",
  DoraTimeToRecovery = "DoraTimeToRecovery",
  DoraDeploymentFrequency = "DoraDeploymentFrequency",
  DoraChangeFailureRate = "DoraChangeFailureRate",
}

export enum OverviewStaticWidget {
  LaunchPad = "LaunchPad",
  Learn = "Learn",
  UserActivity = "UserActivity",
}

type DashboardColumn = Array<{
  value: Widget;
  disabled?: boolean;
  hidden?: boolean;
}>;

export type DashboardColumns = {
  left: DashboardColumn;
  right: DashboardColumn;
};

export type DashboardOverviewStaticColumn = Array<{
  value: OverviewStaticWidget;
  disabled?: boolean;
  hidden?: boolean;
}>;

export type DashboardConfig = Record<
  string,
  {
    overviewColumn?: DashboardOverviewStaticColumn;
    columnMode: ColumnMode;
    title: string;
  } & DashboardColumns
>;

export type DashboardWidgetConfig = {
  title: string;
  component: React.FC;
  moreActions?: {
    title: string;
    analyticsPage: AnalyticsPageDashboard;
    analyticsTitle: string;
    analyticsProps?: Record<string, string>;
    link: string;
  }[];
  infoTooltip?: string;
  headerActions?: React.FC;
  hidden?: boolean;
};
